import flagKeys from '@/constants/flagKeys';

// Lazy-loaded route components
const Login = () => import('@/views/Login/Login.vue');
const EmailFeedback = () => import('@/views/EmailFeedback/EmailFeedback.vue');
const EmailOfferCreationPreview = () =>
  import('@/views/EmailOfferCreationPreview/EmailOfferCreationPreview.vue');
const LoginAdmin = () => import('@/views/Login/LoginAdmin.vue');
const Recovery = () => import('@/views/Recovery/Recovery.vue');
const Forgot = () => import('@/views/Forgot/Forgot.vue');
const Manager = () => import('@/views/Manager/Manager.vue');
const Reports = () => import('@/views/Transactions/Reports.vue');
const InviteNotFound = () => import('@/views/Manager/InviteNotFound.vue');
const ConnectSettings = () =>
  import('@/views/ConnectSettings/ConnectSettings.vue');
const MerchantConnect = () =>
  import('@/views/MerchantConnect/MerchantConnect.vue');
const SocialMediaTemplatesTemplateSelection = () =>
  import('@/views/MarketingCenter/SocialMediaTemplates/TemplateSelection/TemplateSelection.vue');
const SocialMediaTemplatesPostEditor = () =>
  import('@/views/MarketingCenter/SocialMediaTemplates/PostEditor/PostEditor.vue');
const SocialMediaTemplatesPostAssets = () =>
  import('@/views/MarketingCenter/SocialMediaTemplates/AssetsDownload/AssetsDownload.vue');
const OfferFreeCoinsCreation = () =>
  import('@/views/MarketingCenter/OfferFreeCoins/OfferCreation/OfferCreation.vue');
const SellingCoinsCampaignCreation = () =>
  import('@/views/SellCoins/Campaign/SellingCoinsCampaignCreation.vue');
const OfferFreeCoinsDetail = () =>
  import('@/views/MarketingCenter/OfferFreeCoins/OfferDetail/OfferDetail.vue');
const CustomerDetail = () => import('@/views/Performance/CustomerDetail.vue');
const ReferralCreation = () =>
  import('@/views/Referral/ReferralCreation/ReferralCreation.vue');
const ReferralEdit = () =>
  import('@/views/Referral/ReferralEdit/ReferralEdit.vue');
const CustomerImportPreviewEmail = () =>
  import('@/views/MarketingCenter/CustomerImport/CustomerImportPreviewEmail.vue');
const ScoalRewardsCreateCampaign = () =>
  import('@/views/SocialRewards/SocialRewardsCreateCampaign.vue');
const ActivationEmailDetail = () =>
  import('@/views/ActivationEmails/ActivationEmailDetail.vue');
const ActivationEmailPreviewEmail = () =>
  import('@/views/ActivationEmails/ActivationEmailPreviewEmail.vue');
const ValidateToken = () => import('@/views/ValidateToken/ValidateToken.vue');
const SpecialCoinOfferCreation = () =>
  import('@/views/Offers/OfferCreation/OfferCreation.vue');
const SpecialCoinOfferAppPreview = () =>
  import('@/components/organisms/Offers/DataPresentation/AppPreview.vue');
const SpecialCoinOfferDetail = () =>
  import('@/views/Offers/OfferDetail/OfferDetail.vue');
const Maintenance = () => import('@/views/Maintenance/Maintenance.vue');
const MyTools = () => import('@/views/MyTools/MyTools.vue');
const SearchResult = () => import('@/views/SearchResult/SearchResult.vue');
const PurchaseHistory = () =>
  import('@/views/SellCoins/PurchaseHistory/PurchaseHistory.vue');
const AuthTokenBusiness = () => import('@/views/AuthToken/Business.vue');
const BusinessOnboardingOnline = () =>
  import('@/views/BusinessOnboarding/online/BusinessOnboarding.vue');
const BOYourDigitalCoinOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/YourDigitalCoin.vue');
const BOYourAccountOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/YourAccount.vue');
const BOYourStoreOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/YourStore.vue');
const BOLoyaltyWidgetConfigOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/LoyaltyWidgetConfig.vue');
const BOLoyaltyFeedbackStatusOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/LoyaltyFeedbackStatus.vue');
const BORewardRatioOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/RewardRatio.vue');
const BOLoadingOnboarding = () =>
  import('@/views/BusinessOnboarding/online/Steps/LoadingOnboarding.vue');
const BOChooseLoyaltyRewardOnline = () =>
  import('@/views/BusinessOnboarding/online/Steps/ChooseLoyaltyReward.vue');
const BOSelectBusiness = () =>
  import('@/views/BusinessOnboarding/SelectBusiness.vue');
const BOInvitationCreateAccountOwner = () =>
  import('@/views/BusinessOnboarding/direct-link/Steps/Invitation-ownership/InvitationCreateAccount.vue');
const BOInvitationLoginAccountOwner = () =>
  import('@/views/BusinessOnboarding/direct-link/Steps/Invitation-ownership/InvitationLoginAccountOwner.vue');
const FeedbackPlatform = () => import('@/views/Feedback/FeedbackPlatform.vue');
const TransactionItemDetail = () =>
  import('@/componentsV2/organisms/TransactionList/Detail/TransactionItemDetail.vue');
const TestPlaidConnection = () =>
  import('@/views/TestPlaidConnection/TestPlaidConnection.vue');
const ScheduleOnboardingIframe = () =>
  import('@/views/ScheduleOnboardingIframe/ScheduleOnboardingIframe.vue');
const RedirectToHome = () => import('@/views/Home/RedirectToHome.vue');

import { myAccount, changePassword } from './routes';

import { Route } from './route.model';
import { freeCoinsValidator } from '@/router/validators/navbar';
import { getOauthState, isExternalOauthSessionOnline } from './router-utils';
import { homeGroup } from './groups';

const routes = [
  new Route('/', 'login', Login, {
    isResponsive: true,
    authRules: {
      authType: ['super-admin']
    },
    pageView: {
      eventLabel: 'Sign in'
    }
  }),
  new Route('/maintenance', 'maintenance', Maintenance, {
    isResponsive: true
  }),
  new Route('/admin', 'rootLogin', LoginAdmin, {
    isResponsive: true,
    authRules: {
      authType: ['manager']
    }
  }),
  new Route('/r/:typeUser/:token', 'Recovery', Recovery, {
    isResponsive: true,
    pageView: {
      eventLabel: 'Recovery Password'
    }
  }),
  new Route('/n', 'Forgot', Forgot, {
    isResponsive: true,
    pageView: {
      eventLabel: 'Forgot Password'
    }
  }),
  new Route(
    '/online-business-onboarding',
    'online-business-onboarding',
    BusinessOnboardingOnline,
    {
      requiresBusiness: false,
      requiresAuthFree: true
    },
    [
      new Route(
        'your-digital-coin',
        'bo-your-digital-coin',
        BOYourDigitalCoinOnline,
        {
          disableFullLoader: true,
          isResponsive: true,
          zendesk: {
            desktop: {
              position: 'bl'
            },
            mobile: {
              position: 'bl'
            }
          },
          pageView: {
            eventLabel: 'NPO Sign Up/Coin Creation',
            eventProps: () => {
              const data: any = {
                'Signup Online': !!isExternalOauthSessionOnline()
              };
              if (getOauthState())
                data['Provider Name'] = getOauthState().provider.name;
              return data;
            }
          }
        }
      ),
      new Route('your-account', 'bo-your-account', BOYourAccountOnline, {
        disableFullLoader: true,
        isResponsive: true,
        pageView: {
          eventLabel: 'NPO Sign Up/Create Account',
          eventProps: () => {
            const data: any = {
              'Signup Online': !!isExternalOauthSessionOnline()
            };
            if (getOauthState())
              data['Provider Name'] = getOauthState().provider.name;
            return data;
          }
        }
      }),
      new Route('your-store', 'bo-your-store', BOYourStoreOnline, {
        isResponsive: true,
        pageView: {
          eventLabel: 'NPO Sign Up/Business Form',
          eventProps: () => {
            const data: any = {
              'Signup Online': !!isExternalOauthSessionOnline()
            };
            if (getOauthState())
              data['Provider Name'] = getOauthState().provider.name;
            return data;
          }
        }
      }),
      new Route(
        'loading-onboarding',
        'bo-loading-onboarding',
        BOLoadingOnboarding,
        {
          isResponsive: true,
          pageView: {
            eventLabel: 'NPO Sign Up/Loading Onboarding',
            eventProps: () => {
              const data: any = {
                'Signup Online': !!isExternalOauthSessionOnline()
              };
              if (getOauthState())
                data['Provider Name'] = getOauthState().provider.name;
              return data;
            }
          }
        }
      ),
      new Route(
        'choose-loyalty-reward',
        'bo-choose-loyalty-reward',
        BOChooseLoyaltyRewardOnline,
        {
          requiresAuth: true,
          isResponsive: true,
          requiresBusiness: true
        }
      ),
      new Route('reward-ratio', 'bo-reward-ratio', BORewardRatioOnline, {
        requiresAuth: true,
        isResponsive: true,
        requiresBusiness: true,
        pageView: {
          eventLabel: 'NPO Sign Up/Choose Loyalty Reward',
          eventProps: () => {
            const data: any = {
              'Signup Online': !!isExternalOauthSessionOnline()
            };
            if (getOauthState())
              data['Provider Name'] = getOauthState().provider.name;
            return data;
          }
        }
      }),
      new Route(
        'loyalty-widget',
        'bo-loyalty-widget',
        BOLoyaltyWidgetConfigOnline,
        {
          requiresAuth: true,
          isResponsive: true,
          requiresBusiness: true,
          pageView: {
            eventLabel: 'NPO Sign Up/Loyalty Widget Config',
            eventProps: () => {
              const data: any = {
                'Signup Online': !!isExternalOauthSessionOnline()
              };
              if (getOauthState())
                data['Provider Name'] = getOauthState().provider.name;
              return data;
            }
          }
        }
      ),
      new Route(
        'loyalty-feedback-status',
        'bo-loyalty-feedback-status',
        BOLoyaltyFeedbackStatusOnline,
        {
          requiresAuth: true,
          isResponsive: true,
          requiresBusiness: true,
          pageView: {
            eventLabel: 'NPO Sign Up/Loyalty Feedback Status',
            eventProps: () => {
              const data: any = {
                'Signup Online': !!isExternalOauthSessionOnline()
              };
              if (getOauthState())
                data['Provider Name'] = getOauthState().provider.name;
              return data;
            }
          }
        }
      )
    ]
  ),

  new Route(
    '/business-onboarding/select-business',
    'bo-select-business',
    BOSelectBusiness,
    {
      requiresAuth: true,
      isResponsive: true,
      requiresBusiness: true,
      pageView: {
        eventLabel: 'NPO Sign Up/Select Business',
        eventProps: () => {
          const data: any = {
            'Signup Online': !!isExternalOauthSessionOnline()
          };
          if (getOauthState())
            data['Provider Name'] = getOauthState().provider.name;
          return data;
        }
      }
    }
  ),
  new Route(
    '/customer-import/preview-email',
    'customer-import-preview-email',
    CustomerImportPreviewEmail,
    {
      flag: flagKeys.customerImport,
      isResponsive: true,
      requiresAuth: true,
      requiresBusiness: true,
      pageView: {
        eventLabel: 'Invite Customers/Email Preview'
      }
    }
  ),
  new Route('/manager', 'manager', Manager, {
    requiresAuth: true,
    requiresBusiness: false,
    isResponsive: true,
    pageView: {
      eventLabel: 'Sign in/Without Merchant'
    }
  }),
  new Route(
    '/marketing-center/social-media-templates/template-select',
    'marketingCenterTemplateSelection',
    SocialMediaTemplatesTemplateSelection,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: 'marketing-center',
      navbar: {},
      pageView: {
        eventLabel: 'Social Media Assets/Template Select'
      }
    }
  ),
  new Route(
    '/marketing-center/social-media-templates/post/:post/post-editor',
    'marketingCenterPostEditor',
    SocialMediaTemplatesPostEditor,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: 'marketing-center',
      navbar: {},
      pageView: {
        eventLabel: 'Social Media Assets/Edit Post'
      }
    }
  ),
  new Route(
    '/marketing-center/social-media-templates/template/:template/post-editor',
    'marketingCenterPostCreate',
    SocialMediaTemplatesPostEditor,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: 'marketing-center',
      navbar: {},
      pageView: {
        eventLabel: 'Social Media Assets/Post Editor'
      }
    }
  ),
  new Route(
    '/marketing-center/social-media-templates/assets/:post',
    'marketingCenterPostAssets',
    SocialMediaTemplatesPostAssets,
    {
      requiresAuth: false,
      isResponsive: true
    }
  ),
  new Route(
    '/marketing-center/offer-free-coins/create',
    'offer-free-coins-creation',
    OfferFreeCoinsCreation,
    {
      isResponsive: flagKeys.responsiveDashboard,
      validator: () => freeCoinsValidator(),
      requiresAuth: true,
      flag: 'offer-free-coins',
      navbar: {},
      pageView: {
        eventLabel: 'Free Coins/Create'
      }
    }
  ),
  new Route(
    '/sell-coins/campaign/create',
    'campaign-creation',
    SellingCoinsCampaignCreation,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: 'ops-sell-coins-campaign-management',
      navbar: {},
      pageView: {
        eventLabel: 'Selling Coins Campaign/Create'
      }
    }
  ),
  new Route(
    '/sell-coins/purchase-history',
    'purchase-history',
    PurchaseHistory,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: 'ops-sell-coins-campaign-management',
      navbar: {},
      pageView: {
        eventLabel: 'Sell Coins Purchase History'
      }
    }
  ),
  new Route(
    '/marketing-center/offer-free-coins/:campaign',
    'offer-free-coins-detail',
    OfferFreeCoinsDetail,
    {
      isResponsive: flagKeys.responsiveDashboard,
      validator: () => freeCoinsValidator(),
      requiresAuth: true,
      flag: 'offer-free-coins',
      navbar: {},
      pageView: {
        eventLabel: 'Free Coins/Campaign Detail'
      }
    }
  ),
  new Route(
    '/social-rewards/:social/:action',
    'create-new-campaign',
    ScoalRewardsCreateCampaign,
    {
      isResponsive: true,
      requiresAuth: true,
      flag: flagKeys.socialRewards,
      navbar: {},
      pageView: {
        eventLabel: 'Social Rewards/Campaign',
        eventProps: (to: Route) => {
          const path = to.path;
          return {
            action: path.slice(path.lastIndexOf('/') + 1)
          };
        }
      }
    }
  ),
  new Route(
    '/performance/customer-center/:customerId',
    'performance-customer-center-detail',
    CustomerDetail,
    {
      isResponsive: true,
      requiresAuth: true,
      flag: flagKeys.merchantDashboardReports,
      navbar: {},
      pageView: {
        eventLabel: 'Customer Center/Customer Detail'
      }
    }
  ),
  new Route(
    '/performance/transactions-center/:connectTransactionId',
    'performance-transactions-center-detail',
    TransactionItemDetail,
    {
      requiresAuth: true,
      isResponsive: true,
      flag: flagKeys.enableListTransactionsManager,
      navbar: {},
      pageView: {
        eventLabel: 'Transactions Center/Detail'
      }
    }
  ),
  new Route('/referral-program/create', 'referral-creation', ReferralCreation, {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.businessReferral,
    navbar: {},
    pageView: {
      eventLabel: 'Referral Program/Creation'
    }
  }),
  new Route('/referral-program/edit', 'referral-edit', ReferralEdit, {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.businessReferral,
    navbar: {},
    pageView: {
      eventLabel: 'Referral Program/Edit'
    }
  }),
  new Route(
    '/special-coins-offers/create',
    'offer-creation',
    SpecialCoinOfferCreation,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      navbar: {},
      pageView: {
        eventLabel: 'Special Coin Offers/Creation/Change Type'
      }
    }
  ),
  new Route(
    '/special-coins-offers/preview',
    'special-coin-offer-app-preview',
    SpecialCoinOfferAppPreview,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      pageView: {
        eventLabel: 'Special Coin Offers/Preview'
      }
    }
  ),
  new Route(
    '/special-coins-offers/:id',
    'offer-detail',
    SpecialCoinOfferDetail,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      navbar: {},
      pageView: {
        eventLabel: 'Special Coin Offers/Detail'
      }
    }
  ),
  new Route(
    '/activation-emails/:email',
    'activation-emails-detail',
    ActivationEmailDetail,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: flagKeys.customerAcquisition,
      navbar: {},
      pageView: {
        eventLabel: 'Email Automation/See details'
      }
    }
  ),
  new Route(
    '/activation-emails/rewards-invite/preview-email',
    'activation-emails-preview-email',
    ActivationEmailPreviewEmail,
    {
      flag: flagKeys.customerAcquisition,
      isResponsive: true,
      requiresAuth: true,
      requiresBusiness: true,
      pageView: {
        eventLabel: 'Email Automation/Email Preview'
      }
    }
  ),
  new Route(
    '/referral-program/edit-type',
    'referral-edit-type',
    ReferralCreation,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      flag: flagKeys.businessReferral,
      navbar: {},
      pageView: {
        eventLabel: 'Referral Program/Edit Type'
      }
    }
  ),
  new Route('/feedback/platform', 'feedback-platform', FeedbackPlatform, {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: false,
    flag: flagKeys.feedbackPlatform,
    navbar: {},
    pageView: {
      eventLabel: 'Feedback Platform'
    }
  }),
  new Route(
    '/schedule-onboarding-call',
    'schedule-onboarding-call',
    ScheduleOnboardingIframe,
    {
      isResponsive: flagKeys.responsiveDashboard,
      requiresAuth: true,
      pageView: {
        eventLabel: 'Schedule Onboarding Call Iframe'
      }
    }
  ),
  new Route('/transactions/reports', 'transactions_report', Reports, {
    requiresAuth: true,
    flag: flagKeys.transactionsBasicReports,
    navbar: {
      name: 'Basic Reports'
    }
  }),
  myAccount,
  changePassword,
  new Route('/invite/:code', 'manager-invitation', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route('/invite-ownership/:code', 'ownership-invitation', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route(
    '/business-onboarding/your-digital-coin',
    'onboarding-your-digital-coin',
    undefined,
    {
      disableFullLoader: true,
      isResponsive: true
    }
  ),
  // Invite-ownership destinations. The `/business-onboarding` parent that used
  // to carry these was removed in TWISM-15988, so the auth-free/no-business
  // meta is set explicitly here (TWISM-18461).
  new Route(
    '/business-onboarding/invitation-create-account-owner',
    'bo-invitation-create-account-owner',
    BOInvitationCreateAccountOwner,
    {
      requiresAuthFree: true,
      requiresBusiness: false,
      disableFullLoader: true,
      isResponsive: true
    }
  ),
  new Route(
    '/business-onboarding/invitation-login-account-owner',
    'bo-invitation-login-account-owner',
    BOInvitationLoginAccountOwner,
    {
      requiresAuthFree: true,
      requiresBusiness: false,
      disableFullLoader: true,
      isResponsive: true
    }
  ),
  new Route('/invite-merchant/:code', 'merchant-invitation', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route('/ai-signup/:placeId', 'ai-signup', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route(
    '/invite/not-found',
    'manager-invitation-not-found',
    InviteNotFound
  ),
  new Route('/auth/callback/:provider/:type', 'auth-callback', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route('/merchant-connect/oauth', 'merchant-connect-oauth', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    isResponsive: true
  }),
  new Route('/login', 'login-with-token', undefined, {
    requiresAuth: false,
    requiresBusiness: false,
    requiresAuthFree: true
  }),
  new Route('/connect-settings', 'connect-settings', ConnectSettings, {
    requiresBusiness: false,
    requiresAuthFree: true
  }),
  new Route('/features', 'features', MyTools, {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.featuresOnboarding,
    navbar: {
      hideLeftBar: true
    },
    pageView: {
      eventLabel: 'My Tools'
    },
    $group: homeGroup
  }),
  new Route('/search-results', 'search-result', SearchResult, {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.newSearchBar,
    navbar: {
      hideLeftBar: true
    },
    pageView: {
      eventLabel: 'Search Results'
    },
    $group: homeGroup
  }),
  new Route(
    '/test-plaid-connection',
    'test-plaid-connection',
    TestPlaidConnection,
    {
      isResponsive: true,
      requiresAuth: true,
      flag: flagKeys.plaidTestConnect
    }
  ),
  new Route(
    '/merchant-connect/finish',
    'merchant-connect-finish',
    MerchantConnect,
    {
      requiresBusiness: false,
      requiresAuthFree: true
    }
  ),
  new Route('/validate-token', 'validate-token', ValidateToken, {
    requiresAuth: false,
    requiresBusiness: false,
    requiresAuthFree: false
  }),

  // accounts integration
  new Route(
    '/auth/token/business/:businessManagerId',
    'auth-token-business',
    AuthTokenBusiness,
    {
      requiresAuth: false,
      requiresBusiness: false,
      requiresAuthFree: false
    }
  ),

  new Route('/email-feedback/success/:slug', 'email-feedback', EmailFeedback, {
    isResponsive: true,
    requiresAuth: false,
    pageView: {
      eventLabel: 'Email Feedback'
    }
  }),

  new Route(
    '/email-offer-creation-preview/:token',
    'email-offer-creation-preview',
    EmailOfferCreationPreview,
    {
      isResponsive: true,
      requiresAuth: false,
      pageView: {
        eventLabel: 'Email Offer Creation Preview'
      }
    }
  ),
  new Route('*', 'notfound', RedirectToHome)
];

export { routes };
export default routes;
